import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IMedico } from 'src/app/pages/doctors/models/doctor';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';


@Component({
  selector: 'app-tab-medicos',
  templateUrl: './tab-medicos.component.html',
  styleUrls: ['./tab-medicos.component.scss']
})
export class TabMedicosComponent {
  ERoleAdminString = ERoleAdminString;
  @Input() dadosPaginacaoMedicos = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 4,
    totalPaginas: 0,
    itensTotal: 0
  };
  @Input() doctors: IMedico[] = [];
  @Input() companyId?: string;

  @Output() mudouPagina = new EventEmitter();
  @Output() mudouTamanhoPagina = new EventEmitter();
  @Output() recarregarListagem = new EventEmitter();

  constructor(private readonly router: Router) { }

  public abrirEmNovaAba(medicoId: string): void {
    const url = this.router.serializeUrl(this.router.createUrlTree([`/dash/medicos/editar/${medicoId}`]));

    window.open(url, '_blank');
  }
}
